import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTeespringComponent } from './simple-icons-teespring.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTeespringComponent ],
    exports:      [ SimpleIconsTeespringComponent ],
    bootstrap:    []
})
export class SimpleIconsTeespringModule {}
